import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import CommandPalette from "@/components/CommandPalette";
import Layout from "@/components/Layout";
import AuthCallback from "@/components/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Research from "@/pages/Research";
import TradeIdeas from "@/pages/TradeIdeas";
import Chart from "@/pages/Chart";
import Chat from "@/pages/Chat";
import Credits from "@/pages/Credits";
import Agents from "@/pages/Agents";
import AgentDetail from "@/pages/AgentDetail";
import Options from "@/pages/Options";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Security from "@/pages/Security";
import Portfolio from "@/pages/Portfolio";
import Backtest from "@/pages/Backtest";
import AltData from "@/pages/AltData";
import Memory from "@/pages/Memory";
import Brokers from "@/pages/Brokers";
import PublicTrackRecord from "@/pages/PublicTrackRecord";
import VersionFooter from "@/components/VersionFooter";
import TwoFactorChallengeHandler from "@/components/TwoFactorChallengeHandler";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Public routes — NO auth wall, NO chrome.
  if (location.pathname.startsWith("/track-record")) {
    return <PublicTrackRecord />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/research" element={<Research />} />
        <Route path="/trade-ideas" element={<TradeIdeas />} />
        <Route path="/chart" element={<Chart />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/credits" element={<Credits />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/agents/:slug" element={<AgentDetail />} />
        <Route path="/options" element={<Options />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/security" element={<Security />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/backtest" element={<Backtest />} />
        <Route path="/altdata" element={<AltData />} />
        <Route path="/memory" element={<Memory />} />
        <Route path="/brokers" element={<Brokers />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRouter />
          <CommandPalette />
          <TwoFactorChallengeHandler />
          <VersionFooter />
          <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "var(--bg-surface)", border: "1px solid var(--border-default)", color: "var(--text-primary)", fontFamily: "Inter" } }} />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
